import './commonListingStyles.css';
export const commonListingStyles = "cg6dmiz";
export const commonListingLtrStyles = "c1tkzy00";
export const commonListingRtlStyles = "cbzo0rf";